const INIT = 'MODAL_INIT';
const READY = 'MODAL_READY';
const OPEN = 'MODAL_OPEN';
const CLOSE = 'MODAL_CLOSE';
const DESTROY = 'MODAL_DESTROY';

export {
  INIT,
  READY,
  OPEN,
  CLOSE,
  DESTROY,
};



// WEBPACK FOOTER //
// ./src/components/stateful/Modal/STATES.js